/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WebhookSubscription } from '../models/WebhookSubscription';
import type { WebhookSubscriptionCollection } from '../models/WebhookSubscriptionCollection';
import type { WebhookSubscriptionCreateRequest } from '../models/WebhookSubscriptionCreateRequest';
import type { WebhookSubscriptionUpdateRequest } from '../models/WebhookSubscriptionUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WebhookSubscriptionsService {
    /**
     * Lists all webhook subscriptions with optional filtering by client ID, branch ID, and/or event type
     * @returns WebhookSubscriptionCollection Successful operation.
     * @throws ApiError
     */
    public static listWebhookSubscriptions({
        clientId,
        branchId,
        eventType,
        pageSize,
        pageToken,
    }: {
        /**
         * Optional client ID to filter subscriptions
         */
        clientId?: string,
        /**
         * Optional branch ID to filter subscriptions
         */
        branchId?: string,
        /**
         * Optional event type to filter subscriptions
         */
        eventType?: string,
        /**
         * Maximum number of items to return per page
         */
        pageSize?: number,
        /**
         * Token for retrieving the next page of results
         */
        pageToken?: string,
    }): CancelablePromise<WebhookSubscriptionCollection> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/webhookSubscriptions',
            query: {
                'clientId': clientId,
                'branchId': branchId,
                'eventType': eventType,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
        });
    }
    /**
     * Creates a new webhook subscription
     * @returns WebhookSubscription Successful operation.
     * @throws ApiError
     */
    public static createWebhookSubscription({
        requestBody,
    }: {
        requestBody?: WebhookSubscriptionCreateRequest,
    }): CancelablePromise<WebhookSubscription> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/webhookSubscriptions',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Gets details for a specific webhook subscription
     * @returns WebhookSubscription Successful operation.
     * @throws ApiError
     */
    public static getWebhookSubscription({
        subscriptionId,
    }: {
        /**
         * Subscription ID
         */
        subscriptionId: string,
    }): CancelablePromise<WebhookSubscription> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/webhookSubscriptions/{subscriptionId}',
            path: {
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * Updates an existing webhook subscription
     * @returns WebhookSubscription Successful operation.
     * @throws ApiError
     */
    public static updateWebhookSubscription({
        subscriptionId,
        requestBody,
    }: {
        /**
         * Subscription ID
         */
        subscriptionId: string,
        requestBody?: WebhookSubscriptionUpdateRequest,
    }): CancelablePromise<WebhookSubscription> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/webhookSubscriptions/{subscriptionId}',
            path: {
                'subscriptionId': subscriptionId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes a webhook subscription
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static deleteWebhookSubscription({
        subscriptionId,
    }: {
        /**
         * Subscription ID
         */
        subscriptionId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/webhookSubscriptions/{subscriptionId}',
            path: {
                'subscriptionId': subscriptionId,
            },
        });
    }
}
